import { render, staticRenderFns } from "./EventAdmin.vue?vue&type=template&id=36758342&scoped=true&"
import script from "./EventAdmin.vue?vue&type=script&lang=js&"
export * from "./EventAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36758342",
  null
  
)

export default component.exports